import { CFAuthGetRef } from 'auth';
import { locations } from '../../common/redux/action_locations';
import {
  FETCH_OPPORTUNITIES,
  RECEIVED_OPPORTUNITIES,
} from './constants';
import { getCustomQueryParams } from '../'

export function fetchOpportunitiesAction(filters) {
  return {
    type: FETCH_OPPORTUNITIES,
    fetchCall: fetchOpportunities,
    receivedAction: receivedOpportunities,
    data: {
      locations,
      filters,
    },
  };
}

export function fetchOpportunities(filters) {
  let {
    showAgentCoachings,
    queryFilters: { Page, PageSize, SortOrder, SortColumn, customFilters }
  } = filters;

  const map = {
    statusId: 'status.name',
    reasonId: 'reason.name',
    targetKpiId: 'targetkpi.name',
    agentFirstName: 'salesAgent.firstName',
    agentLastName: 'salesAgent.lastName',
    overdueDays: 'isOverdue',
    dateCreated: 'createdDate',
    createdBy: 'originateTeamLead.fullName'
  };
  
  const customQueryParams = getCustomQueryParams(showAgentCoachings, customFilters);
  const Sort = (SortOrder && SortColumn) ? 
  Object.keys(map).includes(SortColumn) ? 
  `${map[SortColumn]} ${SortOrder}` : 
  `${SortColumn} ${SortOrder}` : 
  '';

  return CFAuthGetRef({
    url: `${process.env.REACT_APP_COACHING_API_URL}/api/CoachingOpportunities`,
    params: {
      PageNumber: Page,
      PageSize,
      Sort,
    },
    customQueryParams,
    originURL: process.env.PUBLIC_URL,
    loaderName: 'fetchCoachingOpportunities'
  });
}

export function receivedOpportunities(response) {
  if (!!response) {
    const {
      items = [],
      page = 1,
      pageSize = 25,
      totalCount = 0,
    } = response;

    let remappedItems = items.map(x => ({
      id: x.id,
      agentFirstName: x.salesAgent.firstName,
      agentLastName: x.salesAgent.lastName,
      formType: x.coachingFormType.name,
      formTypeId: x.coachingFormType.id,
      statusId: x.status.id,
      status: x.status.name,
      isOverdue: x.isOverdue,
      overdueDays: x.isOverdue ? `${x.overdueDays} days` : '-',
      reasonId: x.reason.id,
      reason: x.reason.name,
      targetKpiId: x.targetKpi.id,
      targetKpi: x.targetKpi.name,
      dateCreated: x.dateCreatedEst,
      createdBy: x.originateTeamLead && x.originateTeamLead.firstName && x.originateTeamLead.lastName ? 
        x.originateTeamLead.fullName : '-',
    }));

    const data = {
      data: remappedItems,
      Page: page,
      PageSize: pageSize,
      TotalCount: totalCount,
      Pages: Math.ceil(totalCount / pageSize),
    };

    return {
      type: RECEIVED_OPPORTUNITIES,
      data,
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case RECEIVED_OPPORTUNITIES:
      return {
        ...state,
        opportunities: action.data,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/fetchOpportunities.js